<template>
  <div
    class="w-100 d-flex align-items-center justify-content-center"
    :class="{
      'full-page-loader': isFullPage,
    }"
  >
    <b-spinner class="my-5" type="grow" />
  </div>
</template>

<script>

import { BSpinner } from 'bootstrap-vue'

export default {
  name: 'LoadingIndicator',
  components: {
    'b-spinner': BSpinner,
  },
  props: {
    /**
     * teljes magasságú loading indicator kell-e
     */
    isFullPage: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.full-page-loader {
  min-height: 80vh;
}
</style>
